<style scoped lang="scss">

</style>

<template>
  <b-pagination
    :total="data.total"
    v-model="currentPage"
    @change="gotoPage"
    :per-page="perPage"
  >
  </b-pagination>
</template>

<script>
export default {
  name: "LaravelPagination",
  props: {
    data: Object,
    filters: [Object, Array],
  },
  data() {
    return {
      currentPage: this.data.current_page,
      perPage: this.data.per_page
    }
  },
  methods: {
    gotoPage(page) {
      this.$inertia.get(this.data.path, {...this.filters, page}, {
        preserveState: true,
      });
    }
  }
}
</script>
